import React from 'react';
import { Textarea } from "@shadcn-in-nx/ui/textarea";
import { Link } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";
import { CharCount } from "./shared/CharCount";

export function UrlInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSave(value);
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  const errorClass = error ? `w-full h-full rounded-none border-red-500 focus-visible:ring-red-500` : className

  return (
    <div className='w-full h-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Textarea
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => onSave(value)}
                autoFocus={autoFocus}
                minLength={schema?.minLength}
                maxLength={schema?.maxLength}
                className={`resize-none ${errorClass}`}
                inputMode="url"
              />
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
      <CharCount value={value} minLength={schema?.minLength} maxLength={schema?.maxLength} />
    </div>
  );
}
